
    import "src/app/CustomerRequest/index.module.scss?farm_css_modules";
    
    export default {"container": `container-8d5d761d`,"topNav": `topNav-8d5d761d`}
    